import type { ReactNode } from 'react';
import { Avatar, Space, Text, Title } from 'ui';

type P = {
  actions?: ReactNode;
  description?: string;
  icon?: ReactNode;
  name: string;
  photo?: string;
};

const AVATAR_SIZE = 160;

const ChatInfoProfile = ({ actions, description, icon, name, photo }: P) => (
  <Space align="center" block orientation="vertical" size="ms">
    <Avatar icon={icon} photo={photo} size={AVATAR_SIZE} />
    <Space align="center" orientation="vertical" size="xxs">
      <Title className="chat-info-profile__title" ellipsis={{ rows: 2, tooltip: true }} level={1}>
        {name}
      </Title>
      {description ? <Text type="secondary">{description}</Text> : null}
    </Space>
    {actions}
  </Space>
);

export default ChatInfoProfile;
